import { CadastroService } from 'app/shared/services/cadastro.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Observable, of, Subject, forkJoin } from 'rxjs';
import { debounceTime, tap, switchMap, finalize, catchError, delay, filter, map, takeUntil } from 'rxjs/operators';
import { Endereco } from '../../../../../shared/interfaces/endereco';
import { Cidade } from 'app/shared/interfaces/cidade';
import { Estado } from 'app/shared/interfaces/estado';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { PageResult } from 'app/shared/interfaces/page-result';
import { CidadeService } from 'app/shared/services/cidade.service';
import { CepService } from 'app/shared/services/cep.service';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';

@Component({
  selector: 'app-endereco-popup',
  templateUrl: './endereco-popup.component.html',
  styleUrls : ['./endereco-popup.component.scss']
})
export class EnderecoPopupComponent implements OnInit {

  public enderecoForm: FormGroup;

  endereco: Endereco;
  filtroCidades: Cidade[] = [];
  cidades: Cidade[];
  estados: Estado[];
  cadMun: Cidade;
  cep: any;
  isLoading = false;
  isLoadingGrupo = false;
  isLoadingCep = false;
  selectedTabIndex = 0;
  errorMsg: string;
  public searching = false;

  protected _onDestroy = new Subject<void>();
  


  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EnderecoPopupComponent>,
    private fb: FormBuilder, private cidadeService: CidadeService,
    private cepService: CepService,
    private confirmService: AppConfirmService,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit() {
    this.buildItemForm(this.data.payload);
    this.cidadeService.getCidadePage(1, 10).subscribe(c =>this.cidades = c.content);
     /**
     * Search Cidades
     */
       this.enderecoForm.get('searchCidade').valueChanges
       .pipe(
         filter(search => !!search),
         tap(() => this.searching = true),
         takeUntil(this._onDestroy),
         debounceTime(200),
         map(search => {
           if (!this.cidades) {
             return [];
           }
           return this.cidadeService.getCidadePageSearch(1, 10, search).subscribe(cidades => {
             this.cidades = cidades.content;
           });
         }),
         delay(200),
         takeUntil(this._onDestroy)
       )
       .subscribe(result => {
         this.searching = false;
         if (this.endereco?.cadMun !== undefined && this.endereco?.cadMun !== null) {
           if(this.cidades.map(n=>n.id).includes(this.endereco.cadMun.id)){
             const cadMun = this.cidades.find(n=>n.id === this.endereco.cadMun.id)??this.endereco.cadMun;
             if(cadMun!==null && cadMun!== undefined){
               this.enderecoForm.controls['cadMun'].setValue(cadMun);
             }  
           }else{
             this.cidades.push(this.endereco.cadMun);
           }
         }
       },
         error => {
           this.searching = false;
           this.confirmService.confirm(
             {
               message: `A T E N Ç Ã O !  ERRO PESQUISANDO CIDADES ... ${error}`,
               error: true
             });
         }); 
  }

  buildItemForm(endereco: Endereco) {
    const payload = (endereco ?? {}) as Endereco;

    this.enderecoForm = this.fb.group({
      id: [payload.id],
      uuid: [payload.uuid],
      cadastroId: [payload.cadastroId],
      telefone1: [payload.telefone1],
      celular: [payload.celular],
      cep: [payload.cep, [Validators.required]],
      cadMun: [payload.cadMun, [Validators.required]],
      endereco: [payload.endereco, [Validators.required]],
      numero: [payload.numero, [Validators.required]],
      complemento: payload.complemento,
      bairro: [payload.bairro, [Validators.required]],
      uf: [payload.cadMun?.uf],
      email: [payload.email],
      entrega: [payload.entrega ?? false],
      cobranca: [payload.cobranca ?? false],
      padrao: [payload.padrao ?? false],
      searchCidade: ''
    })

    }

  submit() {
    // console.log( this.itemForm.value.endereco);
    // this.itemForm.value.inscricaoFederal = this.itemForm.value.cpfCnpj;
    // this.itemForm.value.cpf = this.itemForm.value.cpfCnpj;
    // this.itemForm.value.rg = this.itemForm.value.rgInscricao;
    // this.itemForm.value.inscricaoEstadual = this.itemForm.value.rgInscricao;
   this.dialogRef.close(this.enderecoForm.value)
  }

  onFocus(event: FocusEvent) {
    this.enderecoForm.get('cadMun').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoading = true),
        switchMap(value => ((typeof(value) === 'string') ?
        this.cidadeService.getCidadePageSearch(1, 10, value ) : new Observable<PageResult<Cidade>>())
         .pipe(
           finalize(() => this.isLoading = false),
         )
       )
      )
      .subscribe(cidades => this.cidades = cidades.content);
  }

  onSelectionChange(event: MatAutocompleteSelectedEvent): void {
    this.cadMun = event.option.value;
    this.enderecoForm.patchValue({uf: this.cadMun.uf});
    this.enderecoForm.patchValue({cadMun: this.cadMun});
  }

  displayFn(cidade: Cidade) {
    if (cidade) {
      return `${cidade.municipio.trim()} - ${cidade.uf.trim()}`;
    }
  }

  consultaCep(cep: string, ignoreEnd = false) {
    console.log('cep digitado: ' + cep);
    cep = cep.replace(/\D/g, '');
    if (cep != null && cep !== '') {
      this.cepService.consulta(cep).subscribe(dados => this.populaEndereco(dados, ignoreEnd));
    }
  }

  populaEndereco(dados: any, ignoreEnd = false) {
    console.log(dados);
    this.cidadeService.getCidadeIbge(dados.ibge).pipe(
      tap(() => this.isLoadingGrupo = true), catchError(_err => {
        console.log(_err);
        this.isLoadingCep = false;
       return of(null);
      })
    ).subscribe(c => {
      this.cadMun = c;
      this.cidades.push(c);
      if (ignoreEnd) {
        this.enderecoForm.patchValue({
          cadMun: this.cadMun,
          uf: this.cadMun.uf
        } );
      } else {
        this.enderecoForm.patchValue({
          endereco: dados.logradouro,
          bairro: dados.bairro,
          cadMun: this.cadMun,
          uf: this.cadMun.uf
        } );
      }
        this.isLoadingGrupo = false
    });
  }


  save() {
    const enderecoAtual = this.enderecoForm.value as Endereco;
    const cadastroId = enderecoAtual?.cadastroId;

    if (!cadastroId) {
      this.persistEndereco(enderecoAtual);
      return;
    }

    this.cadastroService.getPageEndereco(1, 500, 'id', 'ASC', `${cadastroId}`).subscribe(page => {
      const existentes = (page?.content ?? []).filter(e => e?.id !== enderecoAtual?.id);
      const conflitos = this.getConflitosClassificacao(enderecoAtual, existentes);

      if (conflitos.length === 0) {
        this.persistEndereco(enderecoAtual);
        return;
      }

      const msg = `Já existe ${conflitos.join(', ')} marcado(s). Deseja desmarcar automaticamente nos outros endereços e continuar?`;
      this.confirmService.confirm({ title: 'Classificação de Endereço', message: msg }).subscribe(confirmado => {
        if (!confirmado) {
          return;
        }

        this.desmarcarClassificacaoConflitante(enderecoAtual, existentes, () => this.persistEndereco(enderecoAtual));
      });
    });
  }

  private getConflitosClassificacao(enderecoAtual: Endereco, existentes: Endereco[]): string[] {
    const conflitos: string[] = [];

    if (enderecoAtual?.entrega && existentes.some(e => !!e?.entrega)) {
      conflitos.push('Endereço de Entrega');
    }
    if (enderecoAtual?.cobranca && existentes.some(e => !!e?.cobranca)) {
      conflitos.push('Endereço de Cobrança');
    }
    if (enderecoAtual?.padrao && existentes.some(e => !!e?.padrao)) {
      conflitos.push('Endereço Padrão');
    }

    return conflitos;
  }

  private desmarcarClassificacaoConflitante(enderecoAtual: Endereco, existentes: Endereco[], onDone: () => void): void {
    const updates: Observable<Endereco>[] = existentes
      .map(e => {
        const payload: Endereco = { ...e };
        let changed = false;

        if (enderecoAtual?.entrega && payload?.entrega) {
          payload.entrega = false;
          changed = true;
        }
        if (enderecoAtual?.cobranca && payload?.cobranca) {
          payload.cobranca = false;
          changed = true;
        }
        if (enderecoAtual?.padrao && payload?.padrao) {
          payload.padrao = false;
          changed = true;
        }

        return changed ? this.cadastroService.saveOrUpdateEndereco(payload) : null;
      })
      .filter((obs): obs is Observable<Endereco> => !!obs);

    if (updates.length === 0) {
      onDone();
      return;
    }

    forkJoin(updates).subscribe({
      next: () => onDone(),
      error: (err) => {
        this.confirmService.confirm({
          title: 'Erro ao ajustar classificação',
          message: err?.error?.status ?? 'Falha ao desmarcar classificação em endereços existentes.',
          error: true
        });
      }
    });
  }

  private persistEndereco(endereco: Endereco): void {
    this.cadastroService.saveOrUpdateEndereco(endereco).subscribe(
      val => {
        console.log(val);
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, Endereço Salvo com Sucesso!', error: false
        });
      },
      err => {
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR ENDEREÇO, VERIFIQUE',
          message: err?.error?.status ?? 'Erro inesperado ao salvar endereço.', error: true
        })
      });
  }

}
